import api from "./api";

export const postStaff = async (body) => {
  return api
    .post({
      endpoint: "/staff",
      port: process.env.REACT_APP_PORT_OWNER,
      body,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
